<style>
	 @import '@/assets/css/custom.css';
</style>

<template>
	<div>
		<Breadcrumbs main="eSIM" title="View SIM Data" />
 
		<div class="container-fluid">
			<div class="row">
				<div class="col-sm-12">
					
					<div class="card">
						<div class="card-body">

							<div class="col-md-12 project-list filter-sort">
								<div class="row">

                                    <div class="col-md-1">
										<div class="page-loader">
											<button type="button" class="btn btn-light" v-if="!excel.loading" @click="generateExcel()">Excel</button>
											<img class="page-loader" v-else src="@/assets/images/ajax-loader.gif"/>
										</div>
									</div>

									<div class="col-md-2">
										<div class="btn btn-info float-end" @click="openModal">Upload</div>
									</div>

									<div class="col-md-7">

									</div>

                                    <div class="col-md-2 float-end">
										<input type="text" class="form-control" placeholder="Search"  v-model="keyword" @keyup="fetchSimData()"/>
									</div>
								</div>
							</div>
		
							<div class="table-responsive product-table">
								<table class="display" id="basic-1">
									<thead>
										<tr align="center">
											<th>Sl.No</th>
											<th>Primary ICCID</th>
											<th>Secondary ICCID</th>
											<th>Primary MSISDN</th>
											<th>Secondary MSISDN</th>
											<th>Primary & Secondary SIM</th>
											<th>EID</th>
											<th>Primary IMSI</th>
											<th>Secondary IMSI</th>
											<!-- <th>Action</th> -->
										</tr>
									</thead>

									<tbody v-if="Boolean(sims.length)">
										<tr align="center" v-for="(sim, index) in sims" :key="sim.id">
                                            <td>{{from + index}}</td>
											<td>{{sim.primary_ICCID}}</td>
                                            <td>{{sim.secondary_ICCID}}</td>
                                            <td>{{sim.primary_MSISDN}}</td>
                                            <td>{{sim.secondary_MSISDN}}</td>
											<td>{{sim.primary_SIM}} + {{sim.secondary_SIM}}</td>
											<td>{{sim.eid}}</td>
											<td>{{sim.primary_IMSI}}</td>
                                            <td>{{sim.secondary_IMSI}}</td>
                                            <!-- <td></td> -->
                                        </tr>	
									</tbody>

									<tbody v-else>
										<tr>
											<td colspan="12" align="center">No data available in the table</td>
										</tr>

									</tbody> 
								</table>
							</div>

							<!----pagination starts --->
							<nav aria-label="Page navigation" class="mt-2">
								<ul class="pagination">
									<li class="page-item" v-bind:class="[{ disabled: !page.url }, { active: page.active }]" v-for="(page, index) in pagination" :key="page.label">
										<a class="page-link" href="#" @click.prevent="fetchSimData(page.url + '&limit=' + listing_length + '&keyword=' + keyword)" tabindex="-1">
											<span v-if="index == 0">Prev</span>
											<span v-else-if="index == pagination.length - 1">Next</span>
											<span v-else>{{ page.label }}</span>
										</a>
									</li>
								</ul>
							</nav>
							<!----pagination ends --->
		
						</div>
					</div>
				</div>
			</div>
		</div>

		<DynamicModal :title="modal_title">
			<template #body>
				<form @submit.prevent="uploadExcel" enctype="multipart/form-data">
					<div class="row mt-3">
						<div class="col-md-12 form-group">
							<input class="form-control" type="file" @change="setFile($event)" accept=".csv, .xlsx" />
						</div>
					</div>
					
					<div class="col-md-12 form-group mt-3">
						<button type="submit" class="btn btn-primary me-3" v-if="!loading">{{ button_title }}</button>
						<img class="page-loader" v-else src="@/assets/images/ajax-loader.gif"/>
						<button type="button" class="btn btn-light" @click="closeModal()">Close</button>
					</div>
				</form>
			</template>
		</DynamicModal>
	  
   </div>
</template>


<script>
import { onMounted } from 'vue'
import {Modal} from "bootstrap"
import DynamicModal from '@/components/dynamic_modal.vue'
	let dynamicmodal;

	export default {
		name: "Coupons eport",
		components: {
			DynamicModal
		},
		setup(){
			onMounted(() => {
				dynamicmodal = new Modal(document.getElementById('dynamicmodal'));
			})

			const showModal = () => {
				dynamicmodal.show();
			}

			const hideModal = () => {
				dynamicmodal.hide();
			}

			return {
				showModal, hideModal
			}
		},
		
		data() {

			const now = new Date()
			const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
			const today_str = new Date().toJSON().slice(0,10).replace(/-/g,'-')
			const minDate = new Date('2021-01-01') 
	      
			return {
				sims: [],

				file:"",
				Preview_image:"",
				pagination: {},
				start_date: '2021-01-01',
				end_date: today_str,
				
				min: minDate,
				max: today,
				keyword: "",
				listing_length: 10,
				token: "",
				i: 1,				

				modal_title: "Upload Excel",
				button_title: "Upload",

				loading: false,
				excel: {
					loading: false,
				},

			};
		},
		mounted() {},

		created() {
			this.fetchSimData();
		},

		methods: {

			getToken() {
				if (localStorage.getItem('trazio')) {
				var trazio =  JSON.parse(localStorage.getItem('trazio'));
				if(trazio.token) {

					this.token = trazio.token;
					this.user = trazio;
				} else {
					this.$swal("", "Failed to fetch token, please login again", "error");
					this.$router.push({ name: "login" });
				}

				} else {
				this.$swal("", "Session expired, please login again", "error");
				this.$router.push({ name: "login" });
				}
			},

			fetchSimData(page_url = null) {
				this.getToken();
				let url = "/trazio/simData?limit=" + this.listing_length + "&keyword=" + this.keyword;
				page_url = page_url || url;
				this.active_page_url = page_url;
				this.$axios
					.get(page_url, { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						var responseData = res.data.data;
						console.log(responseData);
						this.sims = responseData.simData.data;
						this.pagination = responseData.simData.links;
						this.from = responseData.simData.from;
						this.to = responseData.simData.to;
						this.total = responseData.simData.total;
						// console.log(this.devices);
					})
					.catch((err) => console.log(err));
			},

			setFile(e) {
				this.file = e.target.files[0];
				this.Preview_image = URL.createObjectURL(e.target.files[0]);
				
			},

			uploadExcel() {
				this.getToken();
				this.loading = true;
				const config = {
					headers: {
					"Content-type": "multipart/form-data",
					Accept: "application/json",
					Authorization: "Bearer " + this.token,
					},
				};

				let url = "trazio/uploadSimData";
				{
					{
					this.token;
					}
				}
				let formData = new FormData();
				formData.append("file", this.file);

				this.$axios
					.post(url, formData, config)
					.then((response) => {
						if (response.data.status) {
							this.$swal("", response.data.message, "success");
						} else {
							this.$swal("", response.data.message, "error");
						}
						this.clearForm();
						this.closeModal();
						this.fetchSimData();
						this.loading = false;
					})
					.catch((error) => {
						this.loading = false;
						console.log(error);
						console.log(error.response);
						if (error.response) {
							if (error.response.status == 422) {
								if (error.response.data) {
									this.errors = error.response.data.message;
								}
								this.$swal("", error.response.data.message, "error");
							} else if (error.response.status == 500) {
								this.$swal("", error.response.statusText, "error");
							} else if (error.response.status == 401) {
								this.$swal("", error.response.statusText, "error");
							} else {
								this.$swal("", "Something went wrong", "error");
							}
						} else {
							this.$swal("", error.message, "error");
						}
					});
			},
			generateExcel() {
				this.getToken();
				this.excel.loading = true;
				this.$axios
					.post(
					"/trazio/simExcelReport",
					{}, 
					{
						headers: {
						Authorization: "Bearer " + this.token,
						},
						responseType: "arraybuffer",
					}
					)
					.then((response) => {
						let blob = new Blob([response.data], {
							type: "text/csv;charset=utf-8;",
						});
						const now = new Date();
						const datePart = now.toISOString().slice(0, 10); 
						const timePart = now.toTimeString().slice(0, 8).replace(/:/g, "-"); 

						const fileName = `sim_${datePart}_${timePart}.csv`;

						const link = document.createElement("a");
						link.href = URL.createObjectURL(blob);
						link.download = fileName;
						document.body.appendChild(link);
						link.click();
						document.body.removeChild(link);
						this.excel.loading = false;
					})
					.catch((err) => console.log(err));
			},

			openModal() {
				this.showModal();
				this.clearForm();
			},

			closeModal() {
				this.hideModal();
				this.clearForm();
			},
            
			clearForm() {
				this.edit = false;
				this.file = "";
				this.Preview_image = "";
				this.modal_title = "Upload Excel";
				this.button_title = "Upload";
				this.errors = {};
			},

		},
	};
</script>
